import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {getIsAuthenticated, getUser} from '@vio/core/src/auth/modules/selectors'

import {getApplication, getIsDealFreezeEnabled} from '../modules/selector'
import {setDealFreezeEnabled} from '../modules/slice'

/**
 * Enables Deal Freeze for the brand and currency, and for a signed-in account with an email.
 * @returns boolean indicating if DealFreeze is enabled
 */
export const useDealFreezeEnabled = (): boolean => {
  const dispatch = useDispatch()
  const {isMobile} = useDeviceLayout()
  const {currency, languageCode} = useSelector(getApplication)
  const {retention} = useBrandCapabilities()
  const isAuthenticated = useSelector(getIsAuthenticated)
  const user = useSelector(getUser)
  const isDealFreezeEnabled = useSelector(getIsDealFreezeEnabled)
  const isDealFreezeEnabledForBrand = retention.hasDealFreeze

  const {email} = user?.attributes || {}
  const userHasEmail = Boolean(email)

  useEffect(() => {
    const isUserEligible = !isAuthenticated || userHasEmail

    const shouldEnableDealFreeze = Boolean(
      isDealFreezeEnabledForBrand && currency && isUserEligible
    )
    dispatch(setDealFreezeEnabled(shouldEnableDealFreeze))
  }, [
    isMobile,
    isDealFreezeEnabledForBrand,
    currency,
    dispatch,
    languageCode,
    isAuthenticated,
    userHasEmail
  ])

  return isDealFreezeEnabled
}
